import * as Sentry from '@sentry/nextjs';

export const swrConfig = {
  // https://swr.vercel.app/docs/api
  // This is a generic setup, that does not refresh and does basic json fetching and error handling
  // We can override this in specific components if we need different behavior
  fetcher: fetchJson,
  onError: (err) => {
    // https://swr.vercel.app/docs/error-handling#global-error-report
    Sentry.captureException(err, (scope) => {
      scope.setTransactionName(`SWR Global Fetcher Error: ${err.message}`);
      return scope;
    });
  },
};

export class FetchError extends Error {
  constructor({ message, response, data }) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(message);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, FetchError);
    }

    this.name = 'FetchError';
    this.response = response;
    this.data = data ?? { message: message };
  }
}

export default async function fetchJson(input, init) {
  const response = await fetch(input, init);

  // if the server replies, there's always some data in json
  // if there's a network error, it will throw at the previous line
  const data = await response.json();

  // response.ok is true when res.status is 2xx
  // https://developer.mozilla.org/en-US/docs/Web/API/Response/ok
  if (response.ok) {
    return data;
  }

  throw new FetchError({
    message: response.statusText,
    response,
    data,
  });
}
